import {
  DollarOutlined,
  FileOutlined,
  FileTextOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { hideLinks } from './mock';

const links = [
  {
    text: 'Клиенты',
    rootPath: '/clients',
    icon: UserOutlined,
    sublinks: [
      {
        text: 'Все клиенты',
        path: '/clients/all-clients',
        id: 'client',
      },
      {
        text: 'Все сотрудники',
        path: '/clients/employees/all-employees',
        id: 'worker',
      },
      {
        text: 'Кадровые записи',
        path: '/clients/employees/records',
        id: 'record',
      },
      {
        text: 'Начисления',
        path: '/clients/accruals',
        id: 'accrual',
      },
      {
        text: 'Банковские счета',
        path: '/clients/bank-accounts',
        id: 'bankAccounts',
      },
      {
        text: 'Номенклатура',
        path: '/clients/product-services',
        id: 'productServices',
      },
      {
        text: 'Контрагенты',
        path: '/clients/contractors',
        id: 'contractors',
      },
    ],
  },
  {
    text: 'Документы',
    rootPath: '/documents',
    icon: FileOutlined,
    sublinks: [
      {
        text: 'Первичные документы',
        path: '/documents/source-documents',
        id: 'sourceDocuments',
      },
      {
        text: 'ЭАВР',
        path: '/documents/digital-act-of-completion',
        id: 'awp',
      },
      {
        text: 'ЭСФ',
        path: '/documents/digital-account-invoice',
        id: 'esf',
      },
      {
        text: 'Сделка',
        path: '/documents/deal-documents',
        id: 'dealDocuments',
      },
      {
        text: 'Акт сверки',
        path: '/documents/act-sverki',
        id: 'act_of_reconcilation',
      },
    ],
  },
  {
    text: 'Отчеты',
    rootPath: '/reports',
    icon: FileTextOutlined,
    sublinks: [
      {
        text: 'Форма 910',
        path: '/reports/910',
        id: 'form910',
      },
      {
        text: 'Форма 913',
        path: '/reports/913',
        id: 'form913',
      },
      {
        text: 'Диагностика',
        path: '/reports/diagnostic',
        id: 'diagnostic',
      },
    ],
  },
  {
    text: 'Финансы',
    rootPath: '/payments',
    icon: DollarOutlined,
    sublinks: [
      {
        text: 'Обороты',
        path: '/payments/turns',
        id: 'circulations',
      },
      {
        text: 'Банковские выписки',
        path: '/payments/bank-statements',
        id: 'bank-statements',
      },
      {
        text: 'Касса',
        path: '/payments/kassa',
        id: 'kassas',
      },
      {
        text: 'Карточные платежи',
        path: '/payments/card-payments',
        id: 'cardPayment',
      },
      {
        text: 'Оплата налогов',
        path: '/payments/pay-taxes',
        id: 'cardPayment',
      },
      {
        text: 'Выставленные клиенту',
        path: '/payments/client-payments',
        id: 'paymentRecord',
      },
      {
        text: 'Возвратные платежи',
        path: '/payments/card-payments-reversal',
        id: 'cardPaymentReversal',
      },
      {
        text: 'Отправленные в БЦК',
        path: '/payments/bcc-payments',
        id: 'paymentTaxRecord',
      },
      {
        text: 'Возврат налогов',
        path: '/payments/bcc-refund',
        id: 'paymentTaxRecordRefund',
      },
      {
        text: 'Продажи',
        path: '/payments/sales',
        id: 'clientBought',
      },
      {
        text: 'Подписка',
        path: '/payments/subscribers',
        id: 'subscribers',
      },
      {
        text: 'Объем продаж',
        path: '/payments/statistics/sales',
        id: 'salesStatistics',
      },
    ],
  },
  {
    text: 'ЭДО',
    path: '/edo',
    icon: FileOutlined,
    id: 'alert',
    sublinks: [
      {
        text: 'Уведомления',
        path: '/edo',
        id: 'alert',
      },
    ],
  },

  {
    text: 'Настройки',
    rootPath: '/setting',
    icon: SettingOutlined,
    sublinks: [
      {
        text: 'Справочники',
        rootPath: '/setting/handbooks',
        submenu: [
          {
            text: 'Календарь',
            path: '/setting/handbooks/calendar',
            id: 'calendar',
          },
          {
            text: 'Баланс БЦК',
            path: '/setting/handbooks/balance',
            id: 'balance',
          },
          {
            text: 'Партнеров',
            path: '/setting/handbooks/partners',
            id: 'partnerAccounts',
          },
          {
            text: 'Счета партнеров',
            path: '/setting/handbooks/accounts',
            id: 'partnerAccounts',
          },
          {
            text: 'KATO',
            path: '/setting/handbooks/kato',
            id: 'kato',
          },
          {
            text: 'БВУ',
            path: '/setting/handbooks/bvu',
            id: 'bvu',
          },
          {
            text: 'КБК',
            path: '/setting/handbooks/kbk',
            id: 'kbk',
          },
          {
            text: 'КНП',
            path: '/setting/handbooks/knp',
            id: 'knp',
          },
          {
            text: 'ОКЭД',
            path: '/setting/handbooks/oked',
            id: 'oked',
          },
          {
            text: 'РРП',
            path: '/setting/handbooks/rrp',
            id: 'rrp',
          },
          {
            text: 'ПРП',
            path: '/setting/handbooks/prp',
            id: 'prp',
          },
          {
            text: 'УГД по РК',
            path: '/setting/handbooks/ugd',
            id: 'ugd',
          },
          {
            text: 'ГСВС',
            path: '/setting/handbooks/gsvs',
            id: 'gsvs',
          },
        ],
      },
      {
        text: 'Услуги',
        rootPath: '/setting/services',
        submenu: [
          {
            text: 'Все услуги',
            path: '/setting/services/packages',
            id: 'package_service',
          },
          {
            text: 'Сервисы',
            path: '/setting/services/new-services',
            id: 'service',
          },
          {
            text: 'Опции',
            path: '/setting/services/options',
            id: 'option',
          },
          {
            text: 'Промокоды',
            path: '/setting/services/promocodes',
            id: 'promocode',
          },
          {
            text: 'Промо',
            path: '/setting/services/promo',
            id: 'promo',
          },
          {
            text: 'Скидки услуг',
            path: '/setting/services/discount',
            id: 'discount',
          },
        ],
      },
      {
        text: 'App админка',
        rootPath: '/setting/mobile',
        submenu: [
          {
            text: 'Все истории',
            path: '/setting/mobile/stories',
            id: 'stories',
          },
          {
            text: 'Группы истории',
            path: '/setting/mobile/story-groups',
            id: 'storygroups',
          },
          {
            text: 'События',
            path: '/setting/mobile/main-events',
            id: 'mainEvent',
          },
          {
            text: 'APP Version',
            path: '/setting/mobile/app-version',
            id: 'appVersion',
          },
        ],
      },
      {
        text: 'Web - Админка',
        rootPath: '/setting/web',
        submenu: [
          {
            text: 'Видео инструкции',
            path: '/setting/web/video-instructions',
            id: 'videoInstructions',
          },
          {
            text: 'Вопросы / ответы',
            path: '/setting/web/questions',
            id: 'questions',
          },
          {
            text: 'FAQ',
            path: '/setting/web/faq',
            id: 'faq',
          },
          {
            text: 'Реферальные ссылки',
            path: '/setting/web/refs-links',
            id: 'refs',
          },
          {
            text: 'Страницы Тильда',
            path: '/setting/web/tilda',
            id: 'tilda',
          },
        ],
      },
      {
        text: 'Push Manager',
        rootPath: '/setting/push-manager',
        submenu: [
          {
            text: 'Сегменты',
            path: '/setting/push-manager/segments',
            id: 'segments',
          },
          {
            text: 'Пуш отправки',
            path: '/setting/push-manager/notification',
            id: 'pushNotification',
          },
        ],
      },
      {
        text: 'Интеграция',
        rootPath: '/setting/integration',
        submenu: [
          {
            text: 'ВШЭП КГД',
            path: '/setting/integration/kgd',
            id: 'IntegrationConfig',
          },
          {
            text: 'БЦК',
            path: '/setting/integration/bcc',
            id: 'IntegrationConfig',
          },
          {
            text: 'Firebase',
            path: '/setting/integration/firebase',
            id: 'IntegrationConfig',
          },
          {
            text: 'SMS Шлюз',
            path: '/setting/integration/smsc',
            id: 'IntegrationConfig',
          },
        ],
      },
      {
        text: 'Логирование',
        path: '/setting/logs',
        id: 'logs',
      },
      {
        text: 'CУД',
        rootPath: '/setting/access-manage',
        submenu: [
          {
            text: 'Роли',
            path: '/setting/access-manage/roles',
            id: 'roles',
          },
          {
            text: 'Модули',
            path: '/setting/access-manage/modules',
            id: 'modules',
          },
          {
            text: 'Доступы',
            path: '/setting/access-manage/permissions',
            id: 'permissions',
          },
          {
            text: 'Пользователи',
            path: '/setting/access-manage/users',
            id: 'users',
          },
          {
            text: 'Трайбы',
            path: '/setting/access-manage/tribes',
            id: 'tribe',
          },
          {
            text: 'Группы',
            path: '/setting/access-manage/groups',
            id: 'groups',
          },
        ],
      },
    ],
  },
];

export function filterPermittedLinks({ permissions, isSuperUser }) {
  const copyLinks = [...links];

  if (isSuperUser) {
    return copyLinks;
  }

  const filteredLinks = [];

  copyLinks.forEach((item) => {
    const link = { ...item };
    const hasSublinks = link?.sublinks && link.sublinks.length > 0;
    if (!hasSublinks) {
      if (
        isPermitted(permissions, link.id) &&
        !hideLinks.includes(link.rootPath)
      ) {
        filteredLinks.push(link);
      }
    } else {
      link.sublinks = link.sublinks.filter(
        (sublink) =>
          isPermitted(permissions, sublink.id) &&
          !hideLinks.includes(link.rootPath)
      );

      if (link.sublinks.length > 0) {
        filteredLinks.push(link);
      }
    }
  });

  return filteredLinks;
}

function isPermitted(permissions, pageId) {
  if (!pageId) return false;

  return (
    permissions[pageId] !== undefined && permissions[pageId]?.read === true
  );
}

export const pagesWithClientSelect = new Set([
  '/clients/all-clients',
  '/diagnostic',
  '/documents/source-documents',
  '/documents/act-sverki',
  '/documents/digital-account-invoice',
  '/documents/digital-act-of-completion',
  '/documents/deal-documents',
  '/clients/employees/all-employees',
  '/clients/employees/records',
  '/reports/910',
  '/reports/913',
  '/payments/card-payments',
  '/payments/card-payments-reversal',
  '/payments/client-payments',
  '/payments/bcc-payments',
  '/payments/bcc-payments',
  '/clients/accruals',
  '/payments/turns',
  '/payments/bank-statements',
  '/clients/bank-accounts',
  '/clients/product-services',
  '/clients/contractors',
  '/payments/sales',
  '/logs',
  '/payments/kassa',
]);
